<div class="modal-header">
  <h4 class="modal-title"></h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="share-top-container">
    <div class="share-title">
      Share with other users
    </div>
    <div class="share-switch">
      {{ folder.is_shared ? 'Shared' : 'Share' }} <app-toggle-switch class="toggle-switch" (onChange)="toggleShareSwitch($event)" [checked]="folder.is_shared"></app-toggle-switch>
    </div>
  </div>
  <div class="share-link-container" *ngIf="folder.is_shared">
    <div class="share-link-input">
      <input type="text" ngModel="{{ folder.share_url }}" [disabled]="true" />
      <div class="copy-link" ngxClipboard [cbContent]="folder.share_url" (hidden)="popoverOpen()" (shown)="delayedPopoverClose()" [ngbPopover]="copiedToClipboard" #urlCopied="ngbPopover">
        <i class="fa fa-chain"></i> copy link
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="yes()">Done</button>
</div>

<ng-template #copiedToClipboard>
  <div class="copied-popover"><i class="fa fa-check-circle"></i> Link copied to clipboard</div>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/shared/share-modal/share-modal.component.html